
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FolderItemProps } from ".";
import { loading, find } from "store/folder";

interface ApiFolderFindByIdInputProps {
    id: number;
}

type ApiFolderFindOutputProps = OutputBaseProps<{ item: FolderItemProps; }, ApiFolderFindByIdInputProps>;

export const apiFolderFindById = async (data: ApiFolderFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFolderFindOutputProps>(`/api/folder/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiFolderFindByCodeInputProps {
    code: string;
}

export const apiFolderFindByCode = async (data: ApiFolderFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFolderFindOutputProps>(`/api/folder/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};